import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './conditions-page.component.html',
  styles: [
    '.card-title { text-align: center; }',
    '.card-img-top { height: auto; margin-left: auto; margin-right: auto; max-width: 168px; width: 100%; }',
    ':host ::ng-deep .h2-conditions { text-align: center; }',
    ':host ::ng-deep .p-conditions { text-align: center; }'
  ]
})
export class ConditionsPageComponent implements OnInit {
  /** @private */ data: any;

  constructor(private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit(): void {
    this.data = this.route.snapshot.data;
    this.titleService.setTitle(this.data.content.windowTitle);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/conditions-page.component.ts